import { render } from "./view-page.vue?vue&type=template&id=471a81c2&scoped=true"
import script from "./view-page.vue?vue&type=script&lang=js"
export * from "./view-page.vue?vue&type=script&lang=js"

import "./view-page.vue?vue&type=style&index=0&id=471a81c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-471a81c2"

export default script